module.exports = __webpack_public_path__ + "static/media/hunter-cat-logo.1efb3b57.svg";